/**=========================================================
 * Module: stats.js
 * Stats Controller
 =========================================================*/

App.controller('StatsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
   'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
    "use strict";

    $scope.type = 'statistic';
    $scope.id = $state.params.filter;

    $scope.model = {
    	id: $scope.id,
        dateStatus: 'DELIVERED',
        type: 'words'
    };

    $scope.decimalSep= $rootScope.user.decimalSep;

    $scope.viewstattype = 'words';
    $scope.viewstatkey = 'total';
    $scope.viewstatband = 'total';

    $scope.page = {
            title: $scope.id ? 'labels.STAT' : 'labels.CREATESTAT',
            titleParams: {  },
            subTitle: $scope.id ? '' : ''
        };

    var interval = 1;

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.progress = {
        value: 0
    }
    

    var loadStat = function(){
        D.load('statistic', $scope.id).then(
    			function(data){

    				if(data.result==null || data.result===''){
    					FIREBASE.listen('Stat', data.type.toLowerCase() + $scope.id, function(value){
                            if(value){
                                if(value.error) {
                                    
                                  }
                              $timeout(function(){
                                    $scope.progress.value = value.entities ? Math.round(100 * (value.processed / value.entities)) : 0
                                },10) 
                              if(value.end){
                                $timeout(function(){
                                  loadStat()
                                }, 500)
                              }
                            }
                          }, null, { interval: 60000 })
    				} else {
    					
                        data.projectsData = data.result.projectsData;
    					$scope.model = data;
                        if($scope.model.from)
                            $scope.model.fromString = $filter('display')($scope.model.from, {type:'date'});
                        else
                            $scope.model.fromString = $filter('translate')('labels.ANYTIME');
                        if($scope.model.to)
                            $scope.model.toString = $filter('display')($scope.model.to, {type:'date'});
                        else
                            $scope.model.toString = $filter('translate')('labels.ANYTIME');
    					
                        $scope.page.title = 'labels.STATTYPE'+$scope.model.type.toUpperCase();
    				}
    			}
    	).catch(console.error);
    }

    $scope.init = function(){
        if($rootScope.user.id){
            if(!$scope.id){

                $scope.clients = []; //admin e sg
                $scope.suppliers = []; //*
                $scope.owners = []; //*
                $scope.lines = []; //sg
                $scope.supergroups = []; //admin

                if($rootScope.user.admin){
                    D.query('group','type=client', { cache: false }).then(
                        function(response){
                            $scope.clients = response;
                            $scope.clients.unshift({id:'',name: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                    D.query('supergroup','', { cache: false }).then(
                        function(response){
                            $scope.supergroups = response;
                            
                            $scope.supergroups.unshift({id:'',name: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                }
                if($rootScope.user.sgUser){
                    D.query('group','_sgUser=true', { cache: false }).then(
                        function(response){
                            $scope.clients = response;
                            $scope.clients.unshift({id:'',name: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                    D.load('supergroup', 'mine', { cache: false }).then(
                        function(response){
                            $scope.lines = response.lines;
                            $scope.lines.unshift({id:'',name: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                }
                if($rootScope.user.admin){
                    D.query('group','type=supplier', { cache: false }).then(
                        function(response){
                            $scope.suppliers = response;
                            $scope.suppliers.unshift({id:'',name: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                }
                else {
                    D.query('reference', $rootScope.user.sgUser ? '_sgAll=true' : '', { cache: false }).then(
                        function(response){
                            $scope.suppliers = response;
                            $scope.suppliers.unshift({id:'',fullName: $filter('translate')('labels.ALL') });
                            $scope.initForm();
                        }
                    ).catch(console.error);
                }
                D.query('account', ($rootScope.user.admin ? '' : 'group='+$rootScope.user.group.id), { cache: false }).then(
                		function(response){
                			$scope.owners = response;
                			$scope.owners.unshift({id:'', name: $filter('translate')('labels.ALL') });
                			$scope.initForm();
                		}
                ).catch(console.error);


            } else {

                loadStat();

            }
        }
    }

    $scope.formInitialized = false;
    $scope.initForm = function(){

        if(
            (($scope.clients && $scope.clients.length) || (!$rootScope.user.admin && !$rootScope.user.sgUser)) &&
            ($scope.suppliers && $scope.suppliers.length) &&
            ($scope.owners && $scope.owners.length) && 
            (($scope.lines && ($scope.lines.length || Object.keys($scope.lines).length > 0)) || (!$rootScope.user.sgUser))
        )
            {

            $scope.formInitialized = true;
            
            if($rootScope.user.sgUser){
                $scope.model.client = $rootScope.user.group.id;
            }

            $scope.statForm = {
                    title: '',
                    status: '',
                    type: 'statistic',
                    model: $scope.model,
                    successLabel: 'labels.SUCCESSSAVE',
                    fields: [
                                {
                                    available: true,
                                    type: 'switch',
                                    name: 'type',
                                    label: 'fields.STATTYPE',
                                    options: [{
                                        value: 'words',
                                        label: 'labels.STATTYPEWORDS'
                                    },{
                                        value: 'offers',
                                        label: 'labels.STATTYPEOFFERS'
                                    }]
                                },
                                {
                                    available: $rootScope.user.admin,
                                    type: 'select',
                                    name: 'supergroup',
                                    placeholder: 'labels.ALL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.supergroups,
                                    column: 6,
                                    onchange: function(){
                                        $scope.statForm.fields.filter(function(f){ return f.name=='line';})[0].data = $scope.lines[$scope.model.supergroup];
                                        //$scope.statForm.fields.filter(function(f){ return f.name=='client';})[0].available = !$scope.model.supergroup;
                                        $scope.initForm();
                                    }
                                },{
                                    available: $rootScope.user.admin && !!$scope.model.supergroup,
                                    type: 'select',
                                    name: 'line',
                                    placeholder: 'labels.ALL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.lines[$scope.model.supergroup],
                                    column: 6
                                },
                                {
                                    available: ($rootScope.user.admin && !$scope.model.supergroup) || $rootScope.user.sgUser,
                                    type: 'select',
                                    name: 'client',
                                    placeholder: 'labels.ALL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.clients,
                                    column: 6,
                                    label: $rootScope.user.admin ? 'fields.CLIENT' : 'fields.GROUP',
                                    onchange: function(){
                                        if($rootScope.user.sgUser){
                                            var f = $scope.statForm.fields.filter(function(f){ return f.name=='line';})[1];
                                            var available = $rootScope.user.sgUser && !$scope.model.client;
                                            f.type = available ? 'select' : 'spacer';
                                            f.noLabel = !available;
                                            $scope.statForm.fields.filter(function(f){ return f.name=='line';})[1] = f;
                                        }
                                    }
                                },{
                                    available: $rootScope.user.sgUser,
                                    type: !$scope.model.client ? 'select' : 'spacer',
                                    name: 'line',
                                    placeholder: 'labels.ALL',
                                    valueField: 'id',
                                    labelField: 'name',
                                    data: $scope.lines,
                                    column: 6,
                                    noLabel: !!$scope.model.client
                                },
                                {
                                    available: $scope.model.type==='words',
                                    type: 'select',
                                    name: 'supplier',
                                    placeholder: 'labels.ALL',
                                    valueField: $rootScope.user.admin ? 'id' : 'supplier',
                                    labelField: $rootScope.user.admin ? 'name' : 'supplierName',
                                    data: $scope.suppliers,
                                    column: 6
                                },
                                {
                                    available: false,
                                    type: 'select',
                                    name: 'referent',
                                    placeholder: 'labels.ALL',
                                    valueField: 'referent',
                                    labelField: 'fullName',
                                    data: $scope.referents,
                                    column: 6
                                },{
                                    available: $rootScope.user.admin || $rootScope.user.role=='SUPERUSER',
                                    type: 'multiselect',
                                    data: $scope.owners,
                                    valueField: 'id',
                                    labelField: 'name',
                                    name: 'projectOwner',
                                    label: 'fields.OWNER',
                                    column: 6,
                                    placeholder: 'labels.ALL'
                                },{
                                    available: true,
                                    type: 'empty',
                                    column: 12,
                                    noLabel: true
                                },
                                {
                                    available: $scope.model.type==='words',
                                    type: 'language',
                                    name: 'source',
                                    column: 6,
                                    placeholder: 'labels.ALL',
                                    withEmptyOption: true
                                },{
                                    available: $scope.model.type==='words',
                                    type: 'language',
                                    name: 'destination',
                                    column: 6,
                                    placeholder: 'labels.ALL',
                                    withEmptyOption: true
                                },
                                {
                                    available: true,
                                    type: 'date',
                                    name: 'from',
                                    column: 6,
                                    minDate: new Date(2015,1,1),
                                    onchange: function(){

                                        for(var idx in $scope.statForm.fields){
                                             if($scope.statForm.fields[idx].name=='dateStatus')
                                             if($scope.model.from || $scope.model.to){
                                                $scope.statForm.fields[idx].available = true;
                                            } else {
                                                $scope.statForm.fields[idx].available = false;
                                            }
                                        }

                                    }
                                },
                                {
                                    available: true,
                                    type: 'date',
                                    name: 'to',
                                    column: 6,
                                    minDate: new Date(2015,1,1),
                                    onchange: function(){

                                        for(var idx in $scope.statForm.fields){
                                             if($scope.statForm.fields[idx].name=='dateStatus')
                                             if($scope.model.from || $scope.model.to){
                                                $scope.statForm.fields[idx].available = true;
                                            } else {
                                                $scope.statForm.fields[idx].available = false;
                                            }
                                        }

                                    }
                                },{
                                    available: false,
                                    type: 'radio',
                                    name: 'dateStatus',
                                    options: [{
                                        value: 'CONFIRMED',
                                        label: 'enums.status.CONFIRMED'
                                    },{
                                        value: 'DELIVERED',
                                        label: 'enums.status.DELIVERED'
                                    }],
                                    column: 6,
                                },
                                {
                                    available: true,
                                    type: 'separator'
                                },
                                {
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.RUNSTAT'
                                }

                    ],
                    validate: function(){
                        var errors = [];
                        if(this.model.from && this.model.to && this.model.to.getTime()<this.model.from.getTime()){
                            errors.push({field:this.fields[9],error:'dateToLessThanDateFrom'});
                        }
                        if(errors.length) {
                            var errorMessages ="<ul>";
                            for(var i=0; i<errors.length; i++){
                                var e = errors[i];
                                errorMessages += "<li>"
                                    +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                    +"</li>";
                            }
                            errorMessages += "</ul>";
                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                            return false;
                        }
                        else return true;
                    },
                    submit: function(){
                        if(this.validate()){
                            $scope.statForm.status = 'submitting';
                            D.save($scope.type, $scope.model).then(
                                            function(response){
                                                $scope.statForm.status = 'submitted';
                                                $state.go('app.entity', {action:'view',type:'stats',filter:response.id});
                                            }
                                            
                                        ).catch(function(response){
                                                $scope.statForm.status = 'error';
                                            });
                        }

                    }
                };
        }
    }

    $scope.$watch('model.type', function(){
        if(!$scope.model.result){
            $scope.model = {
            	id: $scope.id,
                dateStatus: 'DELIVERED',
                type: $scope.model.type
            };
            $scope.initForm();
        }
    });

    $rootScope.$watch('user.id', function(){
        $scope.init();
    });

    $scope.$watch('model.client', function(){
    	if($scope.formInitialized && $scope.statForm){
			D.query('account', ($scope.model.client ? 'group='+$scope.model.client : ''), { cache: false }).then(
	        		function(response){
	        			var owners = response;
	        			owners.unshift({id:'', name: $filter('translate')('labels.ALL') });
	        			for(var i in $scope.statForm.fields){
	        				var f = $scope.statForm.fields[i];
	        				if(f.name==='projectOwner'){
	        					f.data = owners;
	        					$timeout(function(){
	        						angular.element('select[name=projectOwner]').chosen('destroy').chosen();
	        					}, 500);
	        				}
	        			}
	        		}
	        ).catch(console.error);
    	}
	});

    $scope.$watch('viewstatband', function(){
    	var band = $scope.viewstatband;
        angular.element('.number-in-chart').css('display','none');
        angular.element('.number-in-chart.'+band).css('display','inline-block');
    });


    $scope.setband = function(band, id){
        $scope.viewstatband = band;
        /*$('.stat-table .total th span').removeClass();
        $('.stat-table .total th span').addClass(band+'-statcolor');*/
        angular.element('.number-in-chart').css('display','none');
        angular.element('.number-in-chart.'+band).css('display','inline-block');
    }

    $scope.recalculate = function(){
            $scope.model.recalculate = true;
            $scope.progress.value = 0;
            D.save($scope.type, $scope.model).then(
                function(response){
                    $scope.model = { id: response.id };
                    loadStat();
                }
            ).catch(console.error);
    };

    $scope.openProjectsData = function(){
    	var scope = $scope.$new();
	    scope.data = $scope.model.projectsData;
        scope.table = {
            title: '',
            filter: false,
            fields: [
                {
                    available: true,
                    hasLink: true,
                    name: 'code',
                    label: 'PROJECTCODE'
                },{
                    available: true,
                    name: 'name'
                },{
                    available: true,
                    name: 'createdOn',
                    type: 'date',
                    def: '-'
                },{
                    available: false && $rootScope.user.groupType!='CLIENT',
                    name: 'client'
                },{
                    available: true,
                    name: 'date',
                    label: 'DATE'+$scope.model.dateStatus.toUpperCase(),
                    type: 'date',
                    def: '-'
                },{
                    available: true,
                    name: 'source',
                    type: 'enum',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'destinations',
                    type: 'enumSet',
                    enumType: 'language'
                },{
                    available: true,
                    name: 'supplier',
                    label: 'CHOSENSUPPLIER'
                },{
                    available: false,
                    name: 'referent'
                },{
                    available: true,
                    name: 'totalWords'
                },{
                    available: true,
                    name: 'normalizedWords'
                },{
                    available: true,
                    name: 'recoveredWords'
                },{
                    available: true,
                    name: 'offerTotal',
                    label: 'TOTALOFFER',
                    type: 'currency',
                    decimalSep: $rootScope.user.decimalSep,
                    currency: $scope.model.currency
                }
            ],
            link: {
                state: 'app.do',
                action: 'open',
                type: 'project',
                filter: 'id'
            }
        };
        ngDialog.close();
	    ngDialog.open({
	      template: '/app/views/entities/stats-projectsdata.html',
	      className: 'ngdialog-theme-large ngdialog-theme-xlarge',
	      scope: scope,
	      cache: false
        });

    };

    $scope.viewAdditionalSavings = function(){
    	var scope = $scope.$new();
	    scope.data = $scope.model.result.total.savings;
        scope.table = {
            title: '',
            filter: false,
            fields: [
                {
                    available: true,
                    hasLink: true,
                    name: 'code',
                    label: 'PROJECTCODE',
                    onclick: function(){
                        ngDialog.close();
                    }
                },{
                    available: true,
                    name: 'date',
                    label: 'DATE',
                    type: 'date',
                    def: '-'
                },{
                    available: true,
                    name: 'value',
                    type: 'currency',
                    style: {
                        width: '50px'
                    }
                },{
                    available: true,
                    name: 'description',
                    type: 'text'
                }
            ],
            link: {
                state: 'app.do',
                action: 'open',
                type: 'project',
                filter: 'project'
            }
        };
        ngDialog.close();
	    ngDialog.open({
	      template: '/app/views/entities/stats-projectsdata.html',
	      className: 'ngdialog-theme-default',
	      scope: scope,
	      cache: false
        });

    };

    $scope.exportToExcel = function(){
        var csv = "\uFEFF";
        var uri = 'data:text/csv;base64,';
        var base64 = function(s) {
            return window.btoa(unescape(encodeURIComponent(s)))
        };

        var c = $rootScope.user.csvSep;

        $('#ProjectsDataTable:first tr').each(function(){
            $('td,th', $(this)).each(function(){
                var text = $.trim($(this).text());
                if(text.indexOf(c)>=0){
                    text = '"' + text.replace(/\"/g, '\\"') + '"';
                }
                csv += text + c;
            });
            csv += '\n';
        })

        var link = document.getElementById('LinkToExport');//document.createElement("a");
        link.download = "stat_"+moment().format('YYYYMMDD')+".csv";
        link.href = uri + base64(csv);
        //link.href = uri + base64(format(template, ctx));
        

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var edge =  ua.indexOf('Edge'); 

        if (msie > 0 || edge>0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
        {
            var blobObject = new Blob([csv], {type: 'text/csv'}); 
            window.navigator.msSaveOrOpenBlob(blobObject, "stat_"+moment().format('YYYYMMDD')+".csv");
            /*txtArea1.contentDocument.open("txt/csv","replace");
            txtArea1.contentDocument.write(csv);
            txtArea1.contentDocument.close();
            txtArea1.focus(); 
            txtArea1.contentDocument.execCommand("SaveAs",true,"stat_"+moment().format('YYYYMMDD')+".csv");*/
        }  else {
            link.click();
        }
    }

  }]);
